import axios from "axios";
const jsonConfig = require("../../Config.json");

const updateRequisitionById = async (Id,payload) => {
 
    try {
        const getAllResponse = await axios.post(
          jsonConfig.apiUrl + "updateRequisitionDetails/"+ Id,payload,
          {
            headers: {
              "x-functions-key": jsonConfig.key,
            },
          }
        );
        return Promise.resolve(getAllResponse);
      } catch (error) {
        return Promise.reject(error);
      }
}

export default updateRequisitionById;